import { invoiceState } from "./invoices/state";
import { invoiceReminderState } from "./invoice-reminders/state";
import { accountingReportState } from "./reports/state";
import { costsState } from "./costs/state";
import { AccountingModulePluginStore } from "./plugin-store";

export const state = {
  ...invoiceState,
  ...invoiceReminderState,
  ...accountingReportState,
  ...costsState,
  ...AccountingModulePluginStore.state,
};
